import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blockService from './blockService';

// Get user from

const initialState = {
  linkBlock: '',
  isLinkError: false,
  isLinkSuccess: false,
  isLinkLoading: false,
  linkErrorMsg: '',
};

export const creatingLinkBlock = createAsyncThunk(
  'linkBlock/creatingLinkBlock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.creatingLinkBlock(headingkData);
      return response;
    } catch (error) {
      const linkErrorMsg =
        (error.response && error.response.data && error.response.data.linkErrorMsg) ||
        error.linkErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(linkErrorMsg);
    }
  }
);
export const linkBlockSlice = createSlice({
  name: 'linkBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.isLinkLoading = false;
      state.isLinkSuccess = false;
      state.isLinkError = false;
      state.linkErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingLinkBlock.pending, (state) => {
        state.isLinkLoading = true;
      })
      .addCase(creatingLinkBlock.fulfilled, (state, action) => {
        state.isLinkLoading = false;
        state.isLinkSuccess = true;
        state.linkBlock = action.payload;
      })
      .addCase(creatingLinkBlock.rejected, (state, action) => {
        state.isLinkLoading = false;
        state.isLinkError = true;
        state.linkErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetUser } = linkBlockSlice.actions;
export default linkBlockSlice.reducer;
